// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonFields = {
  code: "コード",
  name: "名称",
  displayName: "表示名",
  category: "分類",
  architecture: "アーキテクチャ",
  status: "状態",
  visibility: "可視性",
  shareMode: "共有方式",
  usageType: "用途",
  source: "ソース",
  actions: "操作",
  description: "説明",
  tags: "タグ",
  createdAt: "作成日時",
  assetId: "アセット ID",
  declaredQemuGuestAgent: "qemu-guest-agent イメージ内蔵",
  declaredAirangeVmAgent: "airange-vm-agent プリインストールを手動申告",
  declarationScope: "申告の扱い",
  filename: "ファイル名",
  objectSpace: "オブジェクトスペース",
  contentType: "コンテンツタイプ",
  fileSize: "ファイルサイズ",
  declaredPorts: "宣言ポート",
  defaultAccessPorts: "既定アクセスポート",
  transportProtocol: "トランスポートプロトコル",
  guestPort: "Guest ポート",
  serviceProtocol: "サービスプロトコル",
  portLabel: "ポート名",
} as const;
